import { version } from '../../../package.json';
import { PLUGIN_NAME } from './constants';

async function load(app) {
  app.log.debug('loaded example plugin');

  return {
    name: PLUGIN_NAME,
    version
  };
}

load.pluginName = PLUGIN_NAME;

export default load;
